import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { JQLParseError } from './jql-parse-error';
import { JQLSyntaxError } from './jql-syntax-error';
export var JastBuilderErrorListener = /*#__PURE__*/_createClass(function JastBuilderErrorListener() {
  var _this = this;
  _classCallCheck(this, JastBuilderErrorListener);
  _defineProperty(this, "errors", []);
  _defineProperty(this, "syntaxError", function (recognizer, offendingSymbol, line, charPositionInLine, msg) {
    if (offendingSymbol === undefined) {
      _this.errors.push(new JQLParseError(msg));
    } else {
      _this.errors.push(new JQLSyntaxError(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
    }
  });
});